import ninegrid from "../index.js";
import { ngCellEx } from "./_ngCell.js";

class ngTreeItem extends ngCellEx
{
	#pad;
	#target;
	
	constructor () {
		super();

		this.applyBaseStyle();
	}

	connectedCallback() {

		this.shadowRoot.innerHTML = `
			<div class="ng-pad"></div>
			<div class="ng-item">
				<div class="ng-icon">
					<div></div>
				</div>
				<div class="ng-line"></div>
				<div></div>
				<span class="text">${this.displayValue}</span>
			</div>
		`;
		
		super.connectedCallback();
		
		this.#pad = this.shadowRoot.querySelector("div.ng-pad");
		this.#target = this.shadowRoot.querySelector("span");
		
		//this.#init();
	};

	/**
	static get observedAttributes() {
		return ['data-bind'];
	}

	attributeChangedCallback(name, oldValue, newValue) {
		if (name === 'data-bind' && oldValue !== newValue) {
			// data-bind가 바뀔 때마다 그리드에게 컬럼이 변경되었음을 알림
			if (this.owner) this.owner.refreshData();
		}
	} */



	dataRefresh = (v) => {

		const levelField = this.getAttribute("level-bind");
		const level = levelField ? this.owner.data.get(this.row, levelField) : this.value;
		
		var html = '';
		for (var i = 1; i < level; i++) {
			html += '<div class="ng-pad-item"></div>';
		}
		
		this.#pad.innerHTML = html;

		this.#target.innerHTML = this.getDisplayText();
		
		this.#resetTree();
		
		if (!v) this.reset();
		
		$(".ng-icon", this.shadowRoot).off("click", this.#onClick);
		$(".ng-icon", this.shadowRoot).on("click", this.#onClick);
	};
	
	#onClick = e => {

		this.#toggle();
		ninegrid.j.querySelectorAll(e.target).removeClass("ng-expand-on").removeClass("ng-expand-off");
		ninegrid.j.querySelectorAll(e.target).addClass(this.#isExpand ? "ng-expand-on" : "ng-expand-off");
	};

	get prevLevel() {
		var viewIndex = parseInt(this.closest("tr").sectionRowIndex / this.owner.template.length);
		if (!this.owner.dataManager.viewRecords) return -1;

		if (viewIndex != 0) {
			var oRecord = this.owner.data.getNF(viewIndex-1);
			
			return oRecord[this.#getLevelField()];
		}
		else {
			for (var i = parseInt(this.cell.dataset.row) - 1; i >= 0; i--) {
				var data = this.owner.data.get(i);
				if (!data.__ng._[ninegrid.ROW.EXPAND]) return data[this.#getLevelField()];
			}
		}
		
		return -1;
	};
	
	
	get #isExpand() {
		return this.data.__ng._[ninegrid.ROW.EXPAND];
	};

	#resetTree = () => {
		//owner.tree 찾아서 지워야하나?

		const row = this.row;
		if (isNaN(row)) return;
		

		const hasChildren	= this.#hasChildren(row);

		const level			= this.owner.data.get(this.row, this.#getLevelField());

		const nextLevel		= this.#getLevel(row+1);

		const isLast		= this.#isLast(row);


		
		ninegrid.j.querySelectorAll(".ng-icon", this.shadowRoot)
			.removeClass("ng-expand-on").removeClass("ng-expand-off").removeClass("ng-node").removeClass("ng-icon-up").removeClass("ng-icon-down").removeClass("ng-icon-none")
			.addClass(hasChildren ? (this.#isExpand ? "ng-expand-on" : "ng-expand-off") : "ng-node");

		const icon = ninegrid.j.querySelectorAll(".ng-icon", this.shadowRoot);
		if (row == 0) {
			if (isLast) {
				icon.addClass("ng-icon-none");
			}
			else {
				icon.addClass("ng-icon-down");
			}
		} else if (isLast) {
			icon.addClass("ng-icon-up");
		}


		var padItem = $(".ng-pad-item", this.shadowRoot);
		var parentRow = this.#getParentRow(row);

		var cnt = padItem.length;
		while (parentRow >= 0) {
			cnt --;
			var parentIsLast = this.#isLast(parentRow);

			if (parentIsLast) {
				padItem.eq(cnt).addClass("ng-pad-item-none");
			}
			parentRow = this.#getParentRow(parentRow);
		}

		
		if (level < nextLevel) {
			if (this.#isExpand) {
				ninegrid.j.querySelectorAll(".ng-line", this.shadowRoot).addClass("ng-line-down");
			} else {
				ninegrid.j.querySelectorAll(".ng-line", this.shadowRoot).addClass("ng-line-none");
			}
		} else {
			ninegrid.j.querySelectorAll(".ng-line", this.shadowRoot).addClass("ng-line-none");
		}

	};
	
	#toggle = () => {
		this.#expand(!this.#isExpand);
	};
	#expand = (b) => {

		this.data.__ng._[ninegrid.ROW.EXPAND] = b;
		
		this.#setChildVisible(b);


		
		this.owner.data.resetRecords();
		
		this.owner.dataManager.viewRecords.reset();
	};
	#setChildVisible = (b) => {
		
		var arrNF = this.owner.data.getValidDataNF();
		
		const idx = this.owner.data.findIndexNF_1(this.data.__ng._[ninegrid.ROW.INDEX]);
		if (idx < 0) return;
		
		var COL_IDX = this.owner.fields.indexOf(this.#getLevelField());
		var lvl = this.#getLevel(this.row);

		var prev = this.owner.data.getRow(this.row);
		var parentExpand = prev.__ng._[ninegrid.ROW.EXPAND];
		for (var i = idx + 1; i < arrNF.length; i++) {
			var lvl2 = arrNF[i].v[COL_IDX];

			if (lvl2 > prev.v[COL_IDX]) {
				parentExpand = prev.__ng._[ninegrid.ROW.EXPAND];
			}
			else if (lvl2 < prev.v[COL_IDX]) {
				parentExpand = null;
			}
			
			if (lvl2 <= lvl) break;
			
			if (parentExpand == null) {
				arrNF[i].__ng._[ninegrid.ROW.COLLAPSE] = !b;
			}
			else {

				if (parentExpand && b) {
					arrNF[i].__ng._[ninegrid.ROW.COLLAPSE] = false;//!b;
				}
				else if (parentExpand && !b) {
					arrNF[i].__ng._[ninegrid.ROW.COLLAPSE] = true;//!b;			
				}
				else if (!parentExpand && b) {
					arrNF[i].__ng._[ninegrid.ROW.COLLAPSE] = true;//!b;							
				}
				else if (!parentExpand && !b) {
					arrNF[i].__ng._[ninegrid.ROW.COLLAPSE] = true;//!b;
				}
			}

			prev = arrNF[i];
		}
	};

	
	#getParentRow = (row) => {
		if (row <= 0) return -1;
		
		const lvl = this.owner.data.get(row, this.#getLevelField());
		const COL_IDX = this.owner.fields.indexOf(this.#getLevelField());
		const arr = this.owner.data.getValidData();
		
		for (var i = row - 1; i >= 0; i--) {
			//var parentLvl = this.owner.data.get(i, this.cell.dataset.bind);
			const parentLvl = arr[i].v[COL_IDX];
			
			if (lvl > parentLvl) return i;
		}
		
		return -1;
	};
	
	#isLast = (row) => {

		if (ninegrid.isNull(row) || row < 0) throw `invalid row [${row}]`;
		
		if (row + 1 >= this.owner.data.count()) return true;

		
		const currLevel = this.owner.data.get(row, this.#getLevelField());

		const COL_IDX = this.owner.fields.indexOf(this.#getLevelField());
		
		const arr = this.owner.data.getValidData();
		
		for (var i = row + 1; i < arr.length; i++) {
			
			const nextLevel = arr[i].v[COL_IDX];
			//var nextLevel = this.owner.data.get(i, this.cell.dataset.bind);

			if (nextLevel < currLevel) return true;
			if (nextLevel == currLevel) return false;
		}
		
		return true;
	};
	
	#getChildren = () => {

		var arr = [];
		var arrNF = this.owner.data.getValidDataNF();

		var idx = this.owner.data.findIndexNF_1(this.data.__ng._[ninegrid.ROW.INDEX]);
		
		if (idx < 0) throw `invalid row index [${this.data.__ng._[ninegrid.ROW.INDEX]}]`;

		var COL_IDX = this.owner.fields.indexOf(this.#getLevelField());
		const lvl = arrNF[idx].v[COL_IDX];
		
		for (var i = idx + 1; i < arrNF.length; i++) {
			var childLvl = arrNF[i].v[COL_IDX];
			if (lvl >= childLvl) break;
			
			if (childLvl == lvl + 1) arr.push(arrNF[i]);
		}
		
		return arr;
	};
	
	#hasChildren = () => {

		return this.#getChildren().length > 0;
	};

	#getLevelField = () => {

		return this.getAttribute("level-bind") || this.cell.dataset.bind;
	};

	#getLevel = (row) => {

		//if (ninegrid.isNull(row) || row < 0 || this.owner.data.count() >= 0) return -1;//throw `invalid row [${row}]`;
		if (ninegrid.isNull(row) || row < 0 || row >= this.owner.data.count()) return -1;//throw `invalid row [${row}]`;

		return this.owner.data.get(row, this.#getLevelField());
	};
}

if (!customElements.get('ng-tree-item')) {
	customElements.define("ng-tree-item", ngTreeItem);
}